<div class="social-login">
  <button type="button" class="social-btn">
    <app-icon [icon]="iconName.GOOGLE" class="icon" />
  </button>
  <button type="button" class="social-btn">
    <app-icon [icon]="iconName.FACEBOOK" class="icon" />
  </button>
  <button type="button" class="social-btn">
    <app-icon [icon]="iconName.APPLE" class="icon" />
  </button>
  <button type="button" class="social-btn">
    <app-icon [icon]="iconName.TWITTER" class="icon" />
  </button>
</div>
